import OptionTypes from '../../resources/enums/OptionTypes';
import { Option, Task } from '../../store/tasks/types';
import { TaskType } from '../../store/taskTypes/types';
import { autoId } from '../../utils/UidGenerator';

export const handleDescriptionChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
    setTasks: React.Dispatch<React.SetStateAction<Task[]>>,
    task: Task,
    tasks: Task[],
    language: string,
) => {
    setTasks(
        tasks.map((item) => {
            return item.id !== task.id
                ? item
                : {
                      ...task,
                      description: {
                          ...task.description,
                          [language]: e.target.value,
                      },
                  };
        }),
    );
};

export const handleOptionTextChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    setOptions: React.Dispatch<React.SetStateAction<Option[]>>,
    item: Option,
    options: Option[],
    language: string,
) =>
    setOptions(
        options.map((option) => {
            return option.id !== item.id
                ? option
                : {
                      ...item,
                      text: {
                          ...item.text,
                          [language]: e.target.value,
                      },
                  };
        }),
    );

export const handleOptionImageChange = (
    setOptions: React.Dispatch<React.SetStateAction<Option[]>>,
    options: Option[],
    item: Option,
    url: string,
) =>
    setOptions(
        options.map((option) => {
            return option.id !== item.id ? option : { ...item, imageUrl: url };
        }),
    );

export const handleTaskImageChange = (
    url: string,
    setTasks: React.Dispatch<React.SetStateAction<Task[]>>,
    task: Task,
    tasks: Task[],
) => {
    setTasks(
        tasks.map((item) => {
            return item.id !== task.id ? item : { ...task, image: url };
        }),
    );
};

export const handleTaskLanguageVideoUrlChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
    setTasks: React.Dispatch<React.SetStateAction<Task[]>>,
    task: Task,
    tasks: Task[],
    language: string,
) => {
    setTasks(
        tasks.map((item) => {
            return item.id !== task.id
                ? item
                : { ...task, languageVideoUrl: { ...task.languageVideoUrl, [language]: e.target.value } };
        }),
    );
};

export const handleAddPlate = (setOptions: React.Dispatch<React.SetStateAction<Option[]>>, options: Option[]) => {
    setOptions([...options, { id: autoId(), type: OptionTypes.Text }]);
};

export const handleAddImage = (setOptions: React.Dispatch<React.SetStateAction<Option[]>>, options: Option[]) => {
    setOptions([...options, { id: autoId(), type: OptionTypes.Image }]);
};

export const getTaskTypeById = (id: string, taskTypes: TaskType[]) => {
    return taskTypes?.find((x) => x.id === id);
};
